import { FC } from "react";
import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";
import { MemCommonMentionKind } from "@mem-labs/common-editor";
import { StyledCollectionIcon, StyledNoteIcon } from "./dropdown-list-item.style";
import { useThemedCollectionColors } from "@/mds/themes/useThemedCollectionColors";

type Props = {
  kind: MemCommonMentionKind | "create-new-collection";
  collectionId?: string;
};

export const MDSComboboxListItemIcon: FC<Props> = ({ kind, collectionId }) => {
  const isCollection = kind === MemCommonMentionKind.Collection;
  const isNote = kind === MemCommonMentionKind.Note;
  const isCreateNew = kind === "create-new-collection";
  const { iconColor } = useThemedCollectionColors(collectionId);

  if (isCreateNew) {
    return <MdsIcon kind={MdsIconKind.Plus} />;
  }

  if (isCollection) {
    return (
      <StyledCollectionIcon
        aria-label="Collection"
        data-mds-name="combobox-list-item-icon"
        iconColor={iconColor}
      >
        <MdsIcon kind={MdsIconKind.Collection} />
      </StyledCollectionIcon>
    );
  }

  if (isNote) {
    return (
      <StyledNoteIcon aria-label="Note" data-mds-name="combobox-list-item-icon">
        <MdsIcon kind={MdsIconKind.Document} />
      </StyledNoteIcon>
    );
  }

  return null;
};
